import { render } from "./HelpDeskFAQs.vue?vue&type=template&id=12dfc0af&scoped=true"
import script from "./HelpDeskFAQs.vue?vue&type=script&lang=js"
export * from "./HelpDeskFAQs.vue?vue&type=script&lang=js"

import "./HelpDeskFAQs.vue?vue&type=style&index=0&id=12dfc0af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dfc0af"]])

export default __exports__